<template>
    <div class="btn_box">
        <el-button size="small" class="sys-btn-default" @click="goBackClick" style="margin-right: 20px;">{{
            $t('common.cancel') }}</el-button>
        <el-button size="small" type="primary" @click="handleSave">{{ $t('common.confirm') }}</el-button>
    </div>
</template>

<script>
import { MessageBox } from 'element-ui';
export default {
    props: {
        actionBack: {
            type: Number,
            default() {
                return 0
            }
        }
    },
    methods: {
        goBackClick() {
            MessageBox.confirm(vm.$t('common.unsavetip'), vm.$t('common.waring'), {
                distinguishCancelAndClose: true,
                confirmButtonText: vm.$t('common.confirm'),
                cancelButtonText: vm.$t('common.cancel')
            }).then(() => {
                if (this.actionBack === 1) {
                    this.$emit('goBack')
                } else {
                    this.$router.go(-1);
                }
            }).catch(action => {

            });
        },
        handleSave() {
            this.$emit('handleSave');
        }
    }
}
</script>

<style scoped>
.btn_box {
    padding: 20px 0;
    text-align: center;
}
</style>